<template>
  <v-layout
    row
    justify-center
    align-center
    class="authenticator-container"
  >
    <v-card
      align-center
      min-width="460"
      class="px-4 py-4"
    >
      <v-card-text>
        <h3>
          Authenticating tokens...
        </h3>
      </v-card-text>

      <v-card-text>
        <v-progress-circular
          v-if="loading"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        />
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-text>
        <router-link to="/login">
          Back to Sign In
        </router-link>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { setOneLoginUser } from '@/utils/auth';

export default {
  name: 'AuthOneLogin',
  data() {
    return {
      loading: true,
      error: '',
    };
  },
  created() {
    try {
      localStorage.getItem('Exporo.SignIn.redirect');
      const code = this.$route.query.id_token;
      setOneLoginUser({ id_token: code });
      const redirect = localStorage.getItem('Exporo.SignIn.redirect') || '/';
      localStorage.removeItem('Exporo.SignIn.redirect');

      this.$router.push(redirect);
    } catch (e) {
      this.error = e;
    }
  },
};
</script>
<style lang="scss">
.v-card__text {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authOneLogin/AuthOneLogin.vue